import { render, staticRenderFns } from "./NavigatorItemSidebar.vue?vue&type=template&id=e1b93666&"
import script from "./NavigatorItemSidebar.vue?vue&type=script&lang=js&"
export * from "./NavigatorItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports